var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "com-dimensional-list" },
    [
      _c("div", { staticClass: "com-dimensional-list__header mb16" }, [
        _vm._v("\n    " + _vm._s(_vm.name) + "\n  "),
      ]),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }